"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
class Usage extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get overview usage stats of service
     * @param serviceId - service Id
     * @param month - month want to get stats
     * @param year - year want to get stats
     * @returns
     */
    async getOverviewStats(serviceId, month, year) {
        try {
            const data = await this._apiV2.usageAPI.getOverviewStats(serviceId, month, year);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get detail usage stats of service
     * @param serviceId - service Id
     * @param startDate - start time want to get stats, it's time in millisecond, sample: 1686045092927
     * @param endDate - end time want to get stats, it's time in millisecond, sample: 1686045092927
     * @param groupBy - group condition, enum [YEAR, MONTH, WEEK, DAY]
     * @returns
     */
    async getDetailStats(serviceId, startDate, endDate, groupBy) {
        try {
            const data = await this._apiV2.usageAPI.getDetailStats(serviceId, startDate, endDate, groupBy);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = Usage;
